class OrderStatusModal {
  constructor(modalId) {
    this.modal = document.getElementById(modalId);
    this.isOpen = false;
    
    if (this.modal) {
      this.bindEvents();
    }
  }

  bindEvents() {
    // Open modal when "Order Status" link is clicked
    document.addEventListener('click', (e) => {
      // Only trigger if clicking on a link with data-order-status-trigger attribute
      // or a link that specifically has "Order Status" text as its direct content
      const link = e.target.closest('a');
      
      if (link) {
        // Check if link has the data attribute
        if (link.hasAttribute('data-order-status-trigger')) {
          e.preventDefault();
          this.open();
          return;
        }
        
        // Or check if it's specifically an "Order Status" link (exact match, case-insensitive)
        const linkText = link.textContent?.trim().toLowerCase() || '';
        if (linkText === 'order status') {
          e.preventDefault();
          this.open();
        }
      }
    });

    // Close modal only with close button and backdrop
    this.modal.addEventListener('click', (e) => {
      if (e.target.matches('[data-modal-close]') || 
          e.target.closest('[data-modal-close]') ||
          e.target.classList.contains('order-status-modal__backdrop')) {
        this.close();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Close modal when buttons are clicked
    this.modal.addEventListener('click', (e) => {
      if (e.target.closest('.order-status-modal__button')) {
        this.close();
      }
    });
  }

  open() {
    if (this.isOpen) return;
    
    this.modal.style.display = 'flex';
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    this.isOpen = true;
  }

  close() {
    if (!this.isOpen) return;
    
    this.modal.classList.remove('active');
    this.modal.style.display = 'none';
    document.body.style.overflow = '';
    this.isOpen = false;
  }

}

// Initialize modal
document.addEventListener('DOMContentLoaded', function() {
  new OrderStatusModal('order-status-modal-global');
});
